export default "__VITE_ASSET__B58CbWS6__"